<div class="min-vh-100 bg-light">
  <app-header [page]="'Wallets'"></app-header>

  <main class="container py-4">
    <ng-container *ngIf="depositData; else missing">

      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
        <div>
          <h4 class="mb-0 fw-bold">
            {{ isSuccess ? 'Deposit confirmed' : isPending ? 'Deposit processing' : 'Deposit update' }}
          </h4>
          <div class="text-muted small">
            {{ isSuccess
              ? 'Your deposit has been verified successfully.'
              : isPending
                ? 'Your deposit is still being processed.'
                : 'We recorded your deposit update.' }}
          </div>
        </div>

        <div class="d-flex gap-2">
          <button class="btn btn-outline-secondary btn-sm" (click)="newDeposit()">New deposit</button>
          <button class="btn btn-primary btn-sm" (click)="done()">Go to dashboard</button>
          <button *ngIf="returnUrl !== null" class="btn btn-success btn-sm" (click)="backToOrder()">Continue Order</button>
        </div>
      </div>

      <div class="card shadow-sm border-0">
        <div class="card-body p-4">

          <div class="d-flex align-items-start gap-3 mb-4">
            <div class="ack-icon rounded-circle d-flex align-items-center justify-content-center">
              <i
                class="bi fs-3"
                [ngClass]="{
                  'bi-check2': isSuccess,
                  'bi-hourglass-split': isPending,
                  'bi-x': isFailed
                }"></i>
            </div>

            <div class="flex-grow-1">
              <div class="fw-bold fs-5 mb-1">
                {{ isSuccess ? 'Deposit confirmed' : isPending ? 'Deposit pending' : 'Deposit status updated' }}
              </div>

              <div class="text-muted">
                Reference:
                <span class="fw-semibold">{{ depositData.externalReference }}</span>
              </div>

              <div class="text-muted small">
                Created on {{ depositData.createdAt | date:'medium' }}
              </div>

              <div class="text-muted small" *ngIf="depositData.confirmedAt">
                Confirmed on {{ depositData.confirmedAt | date:'medium' }}
              </div>
            </div>

            <span [class]="statusBadgeClass">
              {{ depositData.status | titlecase }}
            </span>
          </div>

          <div class="row g-3">
            <div class="col-12 col-lg-6">
              <div class="p-3 bg-white rounded border">
                <div class="text-muted small mb-1">Amount</div>
                <div class="fs-4 fw-bold">
                  {{ depositData.amount | smartAmount }} {{ depositData.currencyCode }}
                </div>
                <div class="text-muted small">
                  Deposit ID: {{ depositData.depositId }}
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="p-3 bg-white rounded border h-100">
                <div class="text-muted small mb-2">Details</div>

                <div class="d-flex justify-content-between py-1">
                  <span class="text-muted">Gateway</span>
                  <span class="fw-semibold">{{ depositData.gatewayName || depositData.gatewayCode || '-' }}</span>
                </div>

                <div class="d-flex justify-content-between py-1">
                  <span class="text-muted">Gateway Ref</span>
                  <span class="fw-semibold text-truncate" style="max-width: 220px;">
                    {{ depositData.gatewayReference || '-' }}
                  </span>
                </div>

                <div class="d-flex justify-content-between py-1">
                  <span class="text-muted">Checkout Type</span>
                  <span class="fw-semibold">{{ depositData.checkoutType || '-' }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="alert alert-info mt-4 mb-0" *ngIf="isPending">
            <div class="fw-semibold mb-1">What happens next?</div>
            <ul class="mb-0 small">
              <li>Your payment is being verified and applied to your wallet balance.</li>
              <li>You can check your wallet again shortly for the updated status.</li>
              <li>If this takes too long, contact support with your reference.</li>
            </ul>
          </div>

          <div class="alert alert-success mt-4 mb-0" *ngIf="isSuccess">
            <div class="fw-semibold mb-1">Deposit completed</div>
            <div class="small mb-0">
              Your deposit has been confirmed and should reflect in your wallet balance.
            </div>
          </div>

          <div class="alert alert-warning mt-4 mb-0" *ngIf="isFailed">
            <div class="fw-semibold mb-1">Deposit not completed</div>
            <div class="small mb-0">
              Please retry the payment or contact support with your reference.
            </div>
          </div>

          <div class="d-flex flex-wrap gap-2 mt-4">
            <button class="btn btn-outline-secondary" (click)="backToWallet()">View wallet</button>
            <button class="btn btn-primary" (click)="done()">Done</button>
            <button class="btn btn-danger" *ngIf="isFailed" (click)="newDeposit()">Retry Payment</button>
            <button *ngIf="returnUrl !== null" class="btn btn-success" (click)="backToOrder()">Continue Order</button>
          </div>

        </div>
      </div>
    </ng-container>

    <ng-template #missing>
      <div class="card shadow-sm border-0">
        <div class="card-body p-4">
          <div class="fw-bold mb-1">No deposit information found</div>
          <div class="text-muted mb-3">{{ error }}</div>
          <button class="btn btn-primary" (click)="done()">Go to dashboard</button>
        </div>
      </div>
    </ng-template>

    <app-footer></app-footer>
  </main>
</div>